import WpctFbModal from "./modal";

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header.site-header");
  let sticky = false;

  let timeout;
  window.addEventListener("scroll", function () {
    clearTimeout(timeout);

    setTimeout(function () {
      if (window.scrollY > 0) {
        if (!sticky) {
          header.classList.add("is-sticky");
        }
      } else {
        header.classList.remove("is-sticky");
      }

      sticky = window.scrollY > 0 && !sticky;
    }, 20);
  });

  if (window.scrollY > 0) {
    header.classList.add("is-sticky");
  }

  if (!document.body.classList.contains("home")) {
    header.style.backgroundColor = "var(--wp--preset--color--accent-1)";
  }

  WpctFbModal.mount();
});
